import { URLS, CONSTANTS } from '../factories'
import { AuthModule } from '../store'

export default {
  getCloudinaryImageUrl (imageUrl: string) {
    const requestUrl = AuthModule.isProduction ? URLS.production.cloudinaryApiUrl : URLS.replica.cloudinaryApiUrl
    const cloudinaryName = AuthModule.isProduction ? CONSTANTS.production.cloudinaryName : CONSTANTS.replica.cloudinaryName
    return requestUrl + '/' + cloudinaryName + '/image/fetch/w_750/' + imageUrl
  }
}
